import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';

import { OwnAiTitle } from '../../../OwnAI/components/Title';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding: 0;
    }
  }
`;

export const TitleStyles = styled(OwnAiTitle)`
  margin: 8px auto;
`;

export const SubtitleStyles = styled(OnboardingSubtitle)`
  margin: 0 auto 40px !important;
`;

export const OptionsContainerStyles = styled.div`
  margin: 0 16px;
`;
